export default "__VITE_ASSET__BejsUWcs__"